module.exports = __webpack_public_path__ + "img/male-adult-hand.55db63c7.svg";